import { EmployeeModel } from "../models/EmployeeModel";
import React from 'react';

const EmployeeCard: React.FC<{ employee: EmployeeModel, showPrize?: boolean }> = ({ employee, showPrize = false }) => {
  return (
    <div className="p-4 bg-gray-100 rounded-lg shadow-inner">
      <h2 className="text-2xl font-bold text-gray-800">Employee Details</h2>
      <p>
        <strong>Name:</strong> {employee.firstname +' '+ employee.lastname}
      </p>
      <p>
        <strong>Email:</strong> {employee.email}
      </p>
      <p>
        <strong>Organization:</strong> {employee.organization}
      </p>
      <p>
        <strong>Timestamp:</strong> {employee.checkInTimestamp}
      </p>
      <p>
        <strong>Food Restriction:</strong> {employee?.foodRestriction?.trim() || '-'}
      </p>
      <p>
        <strong>Door Gift:</strong> {employee.doorGiftNumber > 0 ? 'Yes' : 'No'}
      </p>
      <p>
        <strong>Door Gift Number:</strong> {employee.doorGiftNumber > 0 ? employee.doorGiftNumber : '-'}
      </p>
      <p>
        <strong>Table Number:</strong> {employee.tableNumber || '-'}
      </p>
    </div>
  );
};

export default EmployeeCard;